import {
  Button,
  CollectionCompilerTemplate,
  CompilerContent,
  CompilerContentBlock,
  Header,
  Input,
} from '@ws/shared';
import { useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { Page } from '../../components/Page';
import { Sidebar } from '../../components/Sidebar';
import { useFetchPreviewByLinkKey } from '../../resources/hooks/useFetchPreviewByLinkKey';

import styles from './PreviewPage.module.css';

export function PreviewPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const { linkKey } = useParams<{ linkKey: string }>();

  const {
    data: preview,
    isLoading,
    isPlaceholderData,
  } = useFetchPreviewByLinkKey(linkKey as string);

  const contentRef = useRef<HTMLDivElement | null>(null);

  function handleGoToReview() {
    console.log('location', location);

    navigate(`${location.pathname}/review`);
  }

  if (isLoading || isPlaceholderData) {
    return <>Loading...</>;
  }

  if (!preview) {
    return <>{'Предпоказ недоступен'}</>;
  }

  return (
    <Page className={styles['preview-page']}>
      <Sidebar />
      <div className={styles['preview-page__playground-wrapper']}>
        <Header
          className={styles['preview-page__header']}
          title={<Input variant="shapeless" value={preview.title} />}
          after={
            <Button className={styles['preview-page__hl-button']} onClick={handleGoToReview}>
              Review
            </Button>
          }
        />
        <div ref={contentRef} className={styles['preview-page__content']}>
          <CollectionCompilerTemplate
            compiledNodes={preview.content.map((part) => (
              <CompilerContentBlock key={part.id} noNoteHighlight>
                <CompilerContent entity={part} />
              </CompilerContentBlock>
            ))}
          />
        </div>
      </div>
    </Page>
  );
}
